import codepen from '@/assets/external-profiles/codepen.jpg'
import dribbble from '@/assets/external-profiles/dribbble.png'
import github from '@/assets/external-profiles/github.jpg'
import linkedin from '@/assets/external-profiles/linkedin.jpg'
import medium from '@/assets/external-profiles/medium.png'
import stackoverflow from '@/assets/external-profiles/stack-overflow.png'
import twitter from '@/assets/external-profiles/twitter.png'
import startsWith from 'lodash/startsWith'

const profiles = {
  'website': {icon: '', label: 'Portfolio', urlPrefix: ''},
  'codepen': { icon: codepen, label: 'CodePen', urlPrefix: 'https://codepen.io/' },
  'dribbble': { icon: dribbble, label: 'Dribbble', urlPrefix: 'https://dribbble.com/' },
  'github': { icon: github, label: 'Github', urlPrefix: 'https://github.com/' },
  'linkedin': { icon: linkedin, label: 'LinkedIn', urlPrefix: 'https://www.linkedin.com/in/' },
  'medium': { icon: medium, label: 'Medium', urlPrefix: 'https://medium.com/' },
  'stackoverflow': { icon: stackoverflow, label: 'Stack Overflow', urlPrefix: 'https://stackoverflow.com/users/' },
  'twitter': { icon: twitter, label: 'Twitter', urlPrefix: 'https://twitter.com/' }
}

const profileLabel = (p) => {
  return profiles[p].label
}

const profileIcon = (p) => {
  return profiles[p].icon
}

const profileLink = (p) => {
  if (p.profileValue.startsWith('http')) {
    return p.profileValue
  }
  const link = `${profiles[p.profileName].urlPrefix}${p.profileValue}`
  if (!startsWith(link, 'http')) {
    return `http://${link}`
  }
  return link
}

export {
  profiles, profileLabel, profileIcon, profileLink
}



// WEBPACK FOOTER //
// ./src/helpers/external-profiles.js